var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductionWhiteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 9.44771 8.44771 9 9 9L15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11L9 11C8.44771 11 8 10.5523 8 10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17071 13C2.06015 12.6872 2 12.3506 2 12C2 10.6875 2.84287 9.57185 4.01686 9.16481C4.22152 5.99623 6.27041 3.33188 9.09958 2.23071C9.4393 0.946516 10.6091 0 12 0C13.3909 0 14.5607 0.946516 14.9004 2.23071C17.7296 3.33188 19.7785 5.99623 19.9831 9.16481C21.1571 9.57185 22 10.6875 22 12C22 12.3506 21.9398 12.6872 21.8293 13H23C23.3788 13 23.725 13.214 23.8944 13.5528C24.0638 13.8916 24.0273 14.297 23.8 14.6L20.8 18.6C20.6112 18.8518 20.3148 19 20 19H4.00001C3.68525 19 3.38886 18.8518 3.20001 18.6L0.200006 14.6C-0.0272575 14.297 -0.0638134 13.8916 0.105579 13.5528C0.274971 13.214 0.621234 13 1.00001 13H2.17071ZM11.0001 2.98891C11.0059 2.44187 11.4514 2 12 2C12.5486 2 12.9941 2.44187 12.9999 2.98891C13.0046 3.42737 13.2944 3.81165 13.7147 3.93672C16.1938 4.67451 18 6.97184 18 9.68842V10C18 10.5523 18.4477 11 19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11C5.55228 11 6 10.5523 6 10V9.68842C6 6.97184 7.80617 4.67451 10.2853 3.93672C10.7056 3.81165 10.9954 3.42737 11.0001 2.98891ZM3.00001 15L4.50001 17H19.5L21 15H3.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionWhiteOutline);
export default __webpack_public_path__ + "static/media/productionWhiteOutline.3aad8b2d88bebb1c57cdca3ab086843d.svg";
export { ForwardRef as ReactComponent };